import { Component } from "react"
import { Container, Image, TextArea, Form, List, Select } from "semantic-ui-react"
import logo from "../../assets/logo.png"
import signature from "../../assets/signature.png"
import { useSelector, useDispatch } from "react-redux"
import { setLetterStep2DataProjectRelevance, setLetterStep2DataAdditional, setLetterStep2DataPartnershipCooperation, setLetterStep2DataProjectIntervention, setLetterStep2DataBudget, setLetterStep2DataCommunication, setLetterStep2DataWorkPlan, setLetterJsOfficer } from "../../redux/projectSlice"

const Step2DetailApproval = () => {
    const dispatch = useDispatch();
    const projectState = useSelector(state => state.project);

    const handleChangeTextArea = (e, data) => {
        if (data.className.split(' ').find(class_ => class_ === 'project-relevance')) {
            dispatch(setLetterStep2DataProjectRelevance(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'partnership-cooperation')) {
            dispatch(setLetterStep2DataPartnershipCooperation(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'project-intervention')) {
            dispatch(setLetterStep2DataProjectIntervention(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'work-plan')) {
            dispatch(setLetterStep2DataWorkPlan(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'communication')) {
            dispatch(setLetterStep2DataCommunication(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'budget')) {
            dispatch(setLetterStep2DataBudget(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'additional')) {
            dispatch(setLetterStep2DataAdditional(data.value));
        } 
    }

    const handleSelectChange = (e, data) => {
        dispatch(setLetterJsOfficer(data.value));
    }

    const renderHeaderDestination = () => {
        const project = projectState.project
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        return (
            <div>
                <Container textAlign='left'>
                    <p>
                        {contact.title} {contact.firstName} {contact.lastName}<br />
                        {lp.nameInEnglish}<br />
                        {lp.addresses[0].houseNumber} {lp.addresses[0].street}<br />
                        {lp.addresses[0].postalCode} {lp.addresses[0].city}<br />
                        {lp.addresses[0].country}<br />
                    </p>
                </Container>
                <Container textAlign='right'>
                    <p>
                        Lille, {projectState.letter?.commission?.step2LetterDate}
                    </p>
                </Container>
            </div>
        )
    }

    const renderLetter = () => {
        const letter = projectState.letter
        const project = projectState.project
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        const title = project.title.filter(title => title.language === 'EN')[0].translation
        const selectedJsOfficer = projectState.jsOfficers.filter(jsOfficer => jsOfficer.value === letter?.jsOfficer)

        return (
            <Container textAlign='justified' className="espace-haut">
                <p>Dear {contact.title} {contact.lastName},</p>
                { project.callSettings?.endDateStep1 === null ?
                    <p>Congratulations! Your Small-Scale Project application <span className="text-accent">{project.customIdentifier} {title} ({project.acronym})</span> has been selected for funding by the NWE Monitoring Committee which took place on {letter?.commission?.step2Date}, in {letter?.commission?.step2Location}. We kindly ask you to inform your project partners.</p>
                    :<p>Congratulations! Your step 2 application <span className="text-accent">{project.customIdentifier} {title} ({project.acronym})</span> has been selected for funding by the NWE Monitoring Committee which took place on {letter?.commission?.step2Date}, in {letter?.commission?.step2Location}. We kindly ask you to inform your project partners.</p>
                }
                {/* <p>Congratulations! Your step 2 application <span className="text-accent">{project.customIdentifier} {title} ({project.acronym})</span> has been selected for funding by the NWE Monitoring Committee which took place on {letter?.commission?.step2Date}, in {letter?.commission?.step2Location}. We kindly ask you to inform your project partners.</p> */}
                <p>The Monitoring Committee has set technical requirements for you to fulfill (annexed to this letter) by <span className="text-accent">{letter?.commission?.technicalRequirementsDeadline}, 12:00 CET (midday)</span> at the latest to be able to proceed with the signature of the subsidy contract.</p>
                <p>If you have not yet submitted your signed partnership agreement, please do so by the set deadline. In case you have already submitted a signed partnership agreement, please verify that it matches the final application form.</p>
                <p>An <span className="text-accent">Approved Projects Seminar</span> will take place on <span className="text-accent">{letter?.commission?.seminarDate} in Lille, France.</span> Please save the date as this seminar is mandatory for all project partners (excluding associated organisations). A maximum of two representatives per project lead partner and one representative per project partner will be invited. These must be people who will be directly involved in the implementation of the project. Information on registration and the agenda will be sent out shortly.</p>
                <p>Please contact your responsible JS officer <Select placeholder="Select officer" defaultValue={selectedJsOfficer} options={projectState.jsOfficers} className="invisible-print" onChange={handleSelectChange} /> {!letter?.jsOfficer ? undefined : <span className="invisible-screen">{letter?.jsOfficer[0]} <span className="text-accent">({letter?.jsOfficer[1]})</span></span>}, as soon as possible to discuss the technical requirements and the process towards contracting.</p>
                <p>Should you have a complaint regarding this decision, you can find more information regarding the available options in Chapter 7 of the Programme Manual.</p>
                <p>Kind regards,</p>
                <Image src={signature} size='small' className="espace-haut-large"/>
                <p>David Grzegorzewski</p>
                <p>Programme Director</p>
            </Container>
        )
    }

    const renderProjectPoints = (data) => {
        const listePoints = data.split(' \n').map(point => point.replace('\n-', '').replace(' /^-+/'))//
        return (
            <List bulleted>
                {listePoints.map(point => {
                    return <List.Item>{point}</List.Item>
                })}
            </List>
        )
    }

    const renderLetterDetails = () => {
        const letter = projectState.letter
        return (
            <Container textAlign='justified' >
                <h3>Technical requirements</h3>
                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.projectRelevance ? <h4>Project relevance</h4> : <h4 className="invisible-print">Project relevance</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print project-relevance" onChange={handleChangeTextArea} value={letter?.step2Data?.projectRelevance}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.projectRelevance}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.partnershipCooperation ? <h4>Partnership and cooperation rationale</h4> : <h4 className="invisible-print">Partnership and cooperation rationale</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print partnership-cooperation" onChange={handleChangeTextArea} value={letter?.step2Data?.partnershipCooperation}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.partnershipCooperation}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.projectIntervention ? <h4>Project intervention logic</h4> : <h4 className="invisible-print">Project intervention logic</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print project-intervention" onChange={handleChangeTextArea} value={letter?.step2Data?.projectIntervention}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.projectIntervention}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.workPlan ? <h4>Workplan</h4> : <h4 className="invisible-print">Workplan</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print work-plan" onChange={handleChangeTextArea} value={letter?.step2Data?.workPlan}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.workPlan}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.communication ? <h4>Communication</h4> : <h4 className="invisible-print">Communication</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print communication" onChange={handleChangeTextArea} value={letter?.step2Data?.communication}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.communication}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.budget ? <h4>Budget</h4> : <h4 className="invisible-print">Budget</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print budget" onChange={handleChangeTextArea} value={letter?.step2Data?.budget}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.budget}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.additional ? <h4>Other</h4> : <h4 className="invisible-print">Other</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print additional" onChange={handleChangeTextArea} value={letter?.step2Data?.additional}>  </TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.additional}</p>
                </div>
            </Container>
        )
    }
    return (
        <div className="margin-notification-letter">
            <table>
                <thead>
                        <div className="print-margin-top-15mm"></div>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <Container className="notification-letter-logo">
                                <Image src={logo} size='medium' />
                            </Container>
                            <Container textAlign="left">
                                {renderHeaderDestination()}
                            </Container>
                            {renderLetter()}
                            <div className="page-break">
                                {renderLetterDetails()}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default Step2DetailApproval;
